<template>
  <transition name="fade">
    <div class='calendar' v-if="getCalendarVisibility">
      <div class='calendar-container'>
        <div class='calendar-line months'>
          <div class='calendar-line-item months-item' @click='moveToPreviousMonth()'>
            <div class="months-arrow-left calendar-line-item-text">&lt;</div>
          </div>
          <div class="calendar-line-item months-item" v-for="m in getFiveCurrentMonths"
            @click='moveToSelectedMonth(m.id)' :key="m.id"
            :class='{ "months-item-selected": m.selected && (m.year === getYearToday), "months-item-unactive": !m.active }'>
            <div class="calendar-line-item-text months-item-text">
              {{ m.label }} {{ m.year.toString().substr(2) }}
            </div>
          </div>
          <div v-if="showTodayBtn" class='calendar-line-item months-item' @click='goToThisMonthAndDay()'>
            <div class="months-arrow-right calendar-line-item-text">Aujourd'hui</div>
          </div>
          <div class='calendar-line-item months-item' @click='moveToNextMonth()'>
            <div class="months-arrow-right calendar-line-item-text">&gt;</div>
          </div>
        </div>
        <div class='calendar-line weekdays'>
          <div class='calendar-line-item weekdays-item' v-for='weekday in getWeekdays' :key="weekday.label">
            <div class="calendar-line-item-text weekdays-item-text">
              {{ weekday.label }}
            </div>
          </div>
        </div>
        <div class='week' v-for='(week, id) in getWeeks' :key="id">
          <calendar-day
            :class='{ "week-day-selected": day.isToday, "not-in-month": !day.inMonth, "week-day-small": (Object.keys(getWeeks).length > 5) }'
            v-for='(day, dayId) in week' :key="dayId" v-bind:day='day'></calendar-day>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
// Calendar based on https://medium.com/@nathanreyes/building-an-extendable-calendar-in-vue-js-part-1-8fb26c04819

import { mapActions, mapGetters, mapMutations } from 'vuex';
import CalendarDay from './CalendarDay';

export default {
  name: 'calendar',
  data() {
    return {
      selectedDate: null
    }
  },
  props: {
    dayKey: { type: String, default: 'day' }
  },
  components: { CalendarDay },
  computed: {
    ...mapGetters({
      getToday: 'calendar/getToday',
      getYear: 'calendar/getYear',
      getMonth: 'calendar/getMonth',
      getYearToday: 'calendar/getYearToday',
      getMonthToday: 'calendar/getMonthToday',
      getSelectedDay: 'calendar/getSelectedDay',
      getMonthIndex: 'calendar/getMonthIndex',
      getIsLeapYear: 'calendar/getIsLeapYear',
      getPreviousMonthComps: 'calendar/getPreviousMonthComps',
      getNextMonthComps: 'calendar/getNextMonthComps',
      getMonths: 'calendar/getMonths',
      getWeekdays: 'calendar/getWeekdays',
      getFirstWeekdayInMonth: 'calendar/getFirstWeekdayInMonth',
      getDaysInMonth: 'calendar/getDaysInMonth',
      getWeeks: 'calendar/getWeeks',
      getCalendarVisibility: 'calendar/getCalendarVisibility',
      getFiveCurrentMonths: 'calendar/getFiveCurrentMonths',
      getDaysIsClosed: 'newServices/getDaysIsClosed'
    }),
    showTodayBtn: function () {
      if (this.getToday.day !== this.getSelectedDay.day || this.getToday.month !== this.getSelectedDay.month || this.getToday.year !== this.getSelectedDay.year) return true
      if (this.getMonthToday !== this.getMonth) return true
      if (this.getYearToday !== this.getYear) return true
      return false
    },
    // State for calendar header
    header() {
      const month = this.getMonths[this.getMonthIndex]
      return {
        month: month,
        year: this.getYear.toString(),
        shortYear: this.getYear.toString().substring(2, 4),
        label: `${month.label} ${this.getYear}`
      }
    }
  },
  methods: {
    ...mapActions({
      findFirstOpenServiceHours: 'newServices/findFirstOpenServiceHours',
      moveToThisMonthAndDay: 'calendar/moveToThisMonthAndDay',
      moveToPreviousMonth: 'calendar/moveToPreviousMonth',
      moveToNextMonth: 'calendar/moveToNextMonth',
      moveToNextYear: 'calendar/moveToNextYear',
      moveToPreviousYear: 'calendar/moveToPreviousYear',
      moveToPreviousDay: 'calendar/moveToPreviousDay',
      moveToNextDay: 'calendar/moveToNextDay',
      initDay: 'calendar/initDay',
      showVisibilityCalendar: 'calendar/showVisibilityCalendar',
      moveToSelectedMonth: 'calendar/moveToSelectedMonth',
      hideAll: 'displayer/hideAll'
    }),
    ...mapMutations({
      setSelectedService: 'newServices/setSelectedService',
      setSelectedRoom: 'newRooms/setSelectedRoom'
    }),
    resetCalendarToday() {
      this.$store.dispatch('office/resetDayToday')
    },
    goToThisMonthAndDay: function () {
      this.moveToThisMonthAndDay().then(() => {
        this.findFirstOpenServiceHours({ day: this.getSelectedDay, keepCurrent: true, passed: false, checkLock: false }).then((tabHS) => {
          this.setSelectedService({ ms: tabHS[Object.keys(tabHS)[0]].tab[0].ms, subs: tabHS[Object.keys(tabHS)[0]].tab[0].subs })
          this.showVisibilityCalendar(false)
          this.setSelectedRoom('')
        })
      })
    }
  },
  created: function () {

  }
}
</script>

<style lang="scss"></style>
